module.exports = __webpack_public_path__ + "img/swiper-4.6223b5e3.png";